/** Select `value` for "+ CREATE NEW PRESET"; must not collide with preset `localId`. */
export const FLEX_IZ_CREATE_NEW_PRESET_OPTION = "__create_new_preset__";
/** Select `value` for "No Ignore Zones"; must not collide with preset `localId`. */
export const FLEX_IZ_NO_IGNORE_ZONES_OPTION = "__no_ignore_zones__";
/**
 * Select `value` for "Default" — the camera's own (camera-level) ignore zones and
 * default line crossings, i.e. no preset applied (ENG-1610). Persists as a
 * `camera-schedule-preset` row with `preset: null`; actuate_admin's settings
 * generator treats a null/absent row as "no preset active" and exports the
 * camera's `polygonal_zones` plus `preset__isnull` lines. Must not collide with
 * preset `localId`s (`server-*`, `custom-*`, `default-*`).
 */
export const FLEX_IZ_DEFAULT_CAMERA_CONFIG_OPTION = "__default_camera_config__";
export const FLEX_IZ_DEFAULT_CAMERA_CONFIG_LABEL = "Default";
